import CategoriesQuery from '@queries/Categories'
import PublicCategoriesQuery from '@queries/PublicCategories'
import graphQL from '@queries'
import * as types from '@store/types'
import getObjectsByAttValue from '@helpers/getObjectByAttValue'

const state = {
  categories: [],
  publicCategories: []
}

const getters = {
  [types.CATEGORIES]: (state) => {
    return state.categories
  },

  [types.CATEGORIES_MENU]: (state) => {
    const menuCategories = getObjectsByAttValue(state.categories, 'is_menu', true)
    const orderedCategories = menuCategories.sort(function (first, last) {
      return first.menu_order - last.menu_order
    }).filter(shelve => shelve !== undefined)

    return orderedCategories.map((category) => ({
      ...category,
      icon: category.menu_icon
    }))
  },

  [types.CATEGORIES_OPTIONS]: (_, getters) => {
    const categories = [...getters[types.CATEGORIES]]
    const options = categories.map((category) => ({
      label: category.name,
      value: category.id
    }))
    return options
  },

  [types.PUBLIC_CATEGORIES]: (state) => {
    return state.publicCategories
  }
}

const mutations = {
  [types.CATEGORIES]: (state, payload) => {
    state.categories = payload
  },
  [types.PUBLIC_CATEGORIES]: (state, payload) => {
    state.publicCategories = payload
  }
}

const actions = {
  [types.CATEGORIES]: async ({ commit }) => {
    const response = await graphQL(CategoriesQuery, {})
    const categories = response.data.data.categories || []
    commit(types.CATEGORIES, categories)
  },

  [types.PUBLIC_CATEGORIES]: async ({ commit }) => {
    const response = await graphQL(PublicCategoriesQuery, {}, true)
    const categories = response.data.data.publicCategories || []
    commit(types.PUBLIC_CATEGORIES, categories)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/category.js